import { compose, combineReducers } from 'redux';
import { mergePersistedState } from 'redux-localstorage';

import { lineItemReducer } from '../lineItem/lineItemModule';
import { addressReducer } from '../address/addressModule';
import { shippingReducer } from "../shipping/shippingModule";

export const stateReducers = {
    lineItems: lineItemReducer,
    shippingGroups: shippingReducer,
    addresses: addressReducer
};

const appReducer = combineReducers(stateReducers);

const reducers = compose(mergePersistedState())(appReducer);

export default reducers;
